module.exports = __webpack_public_path__ + "img/product_info.2f282fe6.png";